<template>
  <div class="rewards root">
    <!-- Top Action Buttons -->
    <ActionButtonsSection :actions="topActions" />

    <Carousel />

    <!-- Points and Coupons Section -->
    <template v-if="coupons.length > 0">
      <div class="section-header">
        <h2 class="section-title">คะแนนและคูปอง</h2>
        <a class="view-all" @click="viewAllCoupons">
          ดูทั้งหมด
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 5L11 9L7 13"
              stroke="#006B2F"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </a>
      </div>
      <div class="coupons-scroll">
        <div class="coupon-item" v-for="(data, index) in coupons" :key="'coupon-' + index">
          <CouponCard :coupon="data" @select="viewCouponDetails($event.id)" />
        </div>
      </div>
    </template>

    <!-- Premium Rewards Section -->
    <div class="section-header">
      <h2 class="section-title">แลกรับสินค้าพรีเมียม</h2>
      <a class="view-all" @click="viewAllRewards">
        ดูทั้งหมด
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 5L11 9L7 13"
            stroke="#006B2F"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </a>
    </div>

    <Category v-show="false" />
    <div class="separate"></div>
    <RewardList />

    <!-- Bottom Banner -->
    <div class="bottom-banner">
      <img src="@/assets/Reward_Footer.jpg" alt="banner" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Carousel from "@/components/carousel.vue";
import Category from "@/components/category.vue";
import RewardList from "@/components/rewardList.vue";
import ActionButtonsSection from "@/components/ActionButtonsSection.vue";
import CouponCard from "@/components/CouponCard.vue";
import { POINT_FESTIVAL, trackFestival } from "@/helper/pointFestival";

export default {
  name: "rewards",
  components: { Carousel, Category, RewardList, ActionButtonsSection, CouponCard },
  data() {
    return {
      pointBtnImg: require("@/assets/bevfam_point_btn.png"),
      rewardBtnImg: require("@/assets/bevfam_reward_btn.png"),
      luckyDrawBtnImg: require("@/assets/bevfam_luckydraw_btn.png"),
    };
  },
  computed: {
    coupons() {
      return (
        this.$store.state.rewards.data?.filter(
          (rw) => rw.categoryId === 24
        ) || []
      );
    },
    topActions() {
      const actions = [
        {
          key: "earn",
          label: "สะสมคะแนน",
          imageSrc: this.pointBtnImg,
          clickHandler: this.onEarnClick,
        },
        {
          key: "redeem",
          label: "แลกรางวัล",
          imageSrc: this.rewardBtnImg,
          clickHandler: this.onRedeemClick,
        },
      ];
      // temporary: Point Festival lucky draw
      if (POINT_FESTIVAL.enabled) {
        actions.push({
          key: "point-festival",
          label: "ลุ้นรางวัล",
          imageSrc: this.luckyDrawBtnImg,
          clickHandler: this.onPointFestivalClick,
        });
      }
      return actions;
    },
  },
  methods: {
    async fetch() {
      // process.env.VUE_APP_API_URL
      return await fetch(process.env.VUE_APP_API_URL + "/rewards", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.$JWT}`,
        },
      });
    },
    async init() {
      let body = [];
      try {
        const res = await this.fetch();
        console.log("fetchRewards status:", res.status);
        switch (res.status) {
          case 200:
            body = await res.json();
            console.log("fetchRewards body:", body);
            this.$store.commit("SET_REWARDS", body);
            this.$store.commit("SET_ACTIVE_CAT_ID", { id: 0 });
            return;
          default: {
            throw "no case status";
          }
        }
      } catch (error) {
        console.log(error);
        this.$store.commit("SET_REWARDS_STATUS", "error");
      }
    },
    viewCouponDetails(code) {
      this.$router.push(`/coupon/${code}`);
    },
    viewAllCoupons() {
      // Navigate to coupons page
      this.$router.push("/coupons");
    },
    viewAllRewards() {
      // Navigate to all rewards page
      this.$router.push("/rewards/all");
    },
    onEarnClick() {
      this.$router.push("/history");
    },
    onRedeemClick() {
      this.$router.push({ path: "/history", query: { tab: "redeem" } });
    },
    onPointFestivalClick() {
      trackFestival("open_from_rewards");
      this.$router.push({ name: "point-festival" });
    },
  },
  mounted() {
    this.init();
    window.loading(false);
  },
};
</script>

<style scoped>
.root {
  font-size: 16px;
  padding: 20px 0px 0px 0px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0px;
  background: #fff;
  overflow-x: hidden;
  width: 100%;
  max-width: 100vw;
}

.section-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 16px;
  gap: 16px;
  width: 100%;
  height: 30px;
  margin-bottom: 18px;
  margin-top: 18px;
}

.section-title {
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #000000;
  margin: 0;
}

.view-all {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
  height: 21px;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: #006b2f;
  text-decoration: none;
  cursor: pointer;
}

.view-all svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.coupons-scroll {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px 0px 4px 16px;
  gap: 12px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 0px;
  width: 100%;
  max-width: 100vw;
}

.coupons-scroll::-webkit-scrollbar {
  display: none;
}

.coupons-scroll::after {
  content: "";
  padding-right: 16px;
}

.coupon-item {
  flex: 0 0 160px;
  width: 160px;
}

.separate {
  display: none;
}

.bottom-banner {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  width: 100%;
  max-width: 100vw;
  height: 92px;
  margin-top: 10px;
}

.bottom-banner img {
  width: 100%;
  max-width: 100vw;
  height: 92px;
  object-fit: cover;
}
</style>


